import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CompaniesWorkers = () => {
  const { t } = useTranslation();

  return (
    <section className="p-5 mb-10 mt-10 w-full m-auto bg-[#006674]">
      <ul className="flex justify-start items-center flex-wrap max-md:gap-3 gap-24 pl-5">
        <li>
          <Link className="text-4xl max-lg:text-xl py-2 uppercase font-bold text-white relative before:top-full before:w-0 before:transition-all
      before:duration-200 before:h-[2px] before:absolute before:bg-white hover:before:w-full"> {t("companies")}</Link>
        </li>
        <li>
          <Link className="text-4xl max-lg:text-xl py-2 uppercase font-bold text-white relative before:top-full before:w-0 before:transition-all
      before:duration-200 before:h-[2px] before:absolute before:bg-white hover:before:w-full">{t("TOPcandidates")}</Link>
        </li>
      </ul>
    </section>
  );
};

export default CompaniesWorkers;
